import { flow, Instance, SnapshotIn, SnapshotOut, types } from "mobx-state-tree";
import { TexHelpersApi } from "../../../api/questions/TexHelpersApi";
import { deserializeTexHelpers } from "./deserializer";

export const TexHelperModel = types.model({
	id: types.identifier,
	code: types.string,
	text: types.maybeNull(types.string),
});

export const TexHelpersModel = types
	.model({
		texHelpers: types.array(TexHelperModel),
	})
	.actions((self) => ({
		getTexHelpers: flow(function* () {
			const response = yield TexHelpersApi.getTexHelpers();
			self.texHelpers = deserializeTexHelpers(response);
		}),
	}))
	.views((self) => ({
		get texHelpersData() {
			return self.texHelpers;
		},
	}));

export interface TexHelpers extends Instance<typeof TexHelpersModel> {}
export interface TexHelper extends Instance<typeof TexHelperModel> {}
export interface TexHelperSnapshotIn extends SnapshotIn<typeof TexHelperModel> {}
export interface TexHelperSnapshotOut extends SnapshotOut<typeof TexHelperModel> {}
